<script lang="ts" setup>
import { useCityStore } from '@/store/city/city'
import { useToggleStore } from '@/store/toggle/toggle'
import { useUserStore } from '@/store/user/user'

import HeaderBurger from '@/components/Header/HeaderBurger.vue'
import HeaderLogo from '@/components/Header/HeaderLogo.vue'
import SupportDialog from '@/components/Header/HeaderNavigationDrawer/SupportDialog.vue'

const DrawerContent = defineAsyncComponent(
  () => import('@/components/Header/HeaderNavigationDrawer/DrawerContent.vue'),
)

const { isTablet } = useResponsive()

const { cityInfo } = useCityStore()
const { isAuthenticated } = storeToRefs(useUserStore())
const { newAddressFlowEnabled } = useToggleStore()

const emit = defineEmits(['on-toggle-navigation'])

const isDialogCallSupportShow = ref(false)
const isCitySelectListShow = ref(false)
const showNavigation = ref(false)

const componentClasses = computed(() => {
  return ['header-mobile', { 'header-mobile--feature': newAddressFlowEnabled }]
})

const onToggleNavigation = () => {
  showNavigation.value = !showNavigation.value

  emit('on-toggle-navigation', showNavigation.value)
}

const onProfileClick = () => {
  isAuthenticated.value ? navigateTo('/profile/orders/') : navigateTo('/login/')
}
</script>

<template>
  <header :class="componentClasses">
    <div class="header-mobile__top">
      <header-logo />

      <div class="header-mobile__city">
        <header-city-select
          v-if="cityInfo.padeg?.imen"
          :is-city-select-list-show="isCitySelectListShow"
          :city-name="cityInfo.padeg.imen"
        />

        <header-working-hours
          @show-city-select-list="isCitySelectListShow = !isCitySelectListShow"
        />
      </div>

      <div class="header-mobile__actions">
        <the-button
          v-if="cityInfo.is_active"
          variant="transparent"
          icon="bubble-chat"
          size="sm"
          radius="lg"
          aria-label="Открыть чат с поддержкой"
          @click="isDialogCallSupportShow = !isDialogCallSupportShow"
        />

        <the-button
          v-if="isTablet"
          variant="transparent"
          icon="user--outline"
          size="sm"
          radius="lg"
          aria-label="Перейти в личный кабинет"
          @click="onProfileClick"
        />

        <header-burger
          :is-active="showNavigation"
          @click="onToggleNavigation"
        />
      </div>
    </div>

    <header-delivery-widget v-if="newAddressFlowEnabled" />

    <the-dialog v-model="isDialogCallSupportShow">
      <support-dialog />
    </the-dialog>
  </header>

  <the-navigation-drawer v-model="showNavigation" top="60" overlay>
    <drawer-content />
  </the-navigation-drawer>
</template>

<style scoped lang="scss">
.header-mobile {
  position: sticky;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1005;
  display: flex;
  flex-direction: column;
  grid-template-columns: max-content 1fr max-content;
  gap: 0 20px;
  align-items: flex-start;
  width: 100%;
  padding: 0 12px 0 20px;
  background: var(--ui-white);
  border-bottom: 1px solid #f1f4f9;

  &--feature {
    padding: 10px 20px 18px 20px;
  }

  &__top {
    position: sticky;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1005;
    display: flex;
    gap: 0 8px;
    align-items: center;
    width: 100%;
    height: 60px;
  }

  &__actions {
    display: flex;
    align-items: center;
    margin-left: auto;
  }
}
</style>
